import { PropType } from "../../base/PropType";
import { Cursor } from "../../base/Cursor";
import { ComponentProps, ComponentPropDefinitions, ComponentPropDefinitionUtil } from "../../base/ComponentProps";
import { Table } from "../..";
import { TableColumn } from "./TableColumn";
import { TableRow } from "./TableRow";
import { PanelPropDefinitions } from "../panel/PanelProps";

export interface TableCellProps extends ComponentProps {
  table: Table;
  col: TableColumn;
  row: TableRow;
  caption: string;
  isHeading: boolean;
}

let tableCellPropDefs: ComponentPropDefinitions;

export class TableCellPropDefinitions {
  public static getDefinitions(): ComponentPropDefinitions {
    if (tableCellPropDefs == null) {
      tableCellPropDefs = {
        caption: { type: PropType.string },
        format: { type: PropType.string },
        ...PanelPropDefinitions.cloneDefs(),
        ...ComponentPropDefinitionUtil.getDataBoundPropertyDefinitions()
      };
      tableCellPropDefs.cursor.defaultValue = Cursor.POINTER;
      ComponentPropDefinitionUtil.populateComponentPropNames(tableCellPropDefs);
    }
    return tableCellPropDefs;
  }
}
